// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Label/Label.sass
// module id = 420
// module chunks = 0